/*
 * Copyright (c) 2005-2024, Paycheck Planner
 * All rights reserved
 * 
 */

import React, { useEffect } from "react";
import { Navigate, useNavigate, useLocation } from 'react-router-dom';

import { Row, Col } from "react-bootstrap";

import { useUnsecurePost } from "../components/fetchHook";
import getPCPUrl from "../components/pcpUrl";



export default function UserVerification(props) {
  const navigate = useNavigate();
  const { postData, response, isLoading, error } = useUnsecurePost();
  const location = useLocation();


  useEffect( async () => {
    let s = location.search;

    let body = {
      query: ""
    }

    if (s.length > 10) { // is much bigger but its at least 10
      body.query = s.substring(5); // ?qry=
    }
    

    let url = getPCPUrl() + "verifyUser";
    await postData(url, JSON.stringify(body));
  }, []);


  function Greeting(props) {

    return (
      <h3>Congradulations. You have successfully registered and can now log into the system.</h3>
    );
  }



  let error_style = {
    background: "#ffcccc",
    textAlign: "center",

    marginTop: "10px"
  }

  let hr_style = {
    textAlign: "center",

    marginBottom: "10px"
  }


  return (
    <Row>
      <Col lg={{ span: 6, offset: 3 }}>
        <h2 style={hr_style}>Verification</h2>

        {isLoading && <span>Verying email ...<i className="fas fa-spinner fa-spin"></i></span> }

        {response !== null && <Greeting />}

        {error.length > 0 ? <div style={error_style}><p>{error}</p></div> : null}
      </Col>

    </Row>
  );

};

